import { faFolderPlus, faPlay, faStop } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FunctionComponent, useContext } from 'react';
import { Stack } from '../../../../server/src/models';
import { EnvironmentContext } from '../context';

type ActionButtonProperties = {
  stack: Stack;
};

const ActionButton: FunctionComponent<ActionButtonProperties> = ({ stack }) => {
  const classEnabled =
    'float-right py-1 px-2 mr-2 mb-2 text-xs font-medium text-gray-900 focus:outline-none bg-neutral-50 rounded-lg border border-gray-200 hover:scale-125 hover:bg-gray-100 hover:text-red-500 focus:z-10 focus:ring-4 focus:ring-gray-200 group transition-all ease-in-out duration-300';
  /**
   const classDisabled =
   'cursor-not-allowed float-right py-1 px-2 mr-2 mb-2 text-xs font-medium text-gray-500 focus:outline-none bg-neutral-50 rounded-lg border border-gray-200 hover:scale-125 focus:z-10 hover:text-red-300 focus:ring-4 focus:ring-gray-200 group transition-all ease-in-out duration-300  group transition-all ease-in-out duration-300';
   */
  const ctx = useContext(EnvironmentContext);
  const { createStack, startStack, stopStack } = ctx.actions;
  //const { env } = ctx.state;

  const callCreateStack = (stack: Stack) => {
    createStack({
      name: stack.name,
      frontendTag: stack.frontendImage.tag,
      backendTag: stack.backendImage.tag,
      stockerTag: stack.stockerImage.tag
    });
  };

  return (
    <>
      {(stack.stackState === 'NOT_CREATED' || stack.stackState === 'DELETED') && (
        <button type="button" onClick={() => callCreateStack(stack)} className={classEnabled}>
          <FontAwesomeIcon icon={faFolderPlus} />
          &nbsp;&nbsp;Create
        </button>
      )}
      {stack.stackState === 'composing' && (
        <button type="button" onClick={() => stopStack(stack)} className={classEnabled}>
          <FontAwesomeIcon icon={faStop} />
          &nbsp;&nbsp;
          <span className="group-hover:hidden">Ready</span>
          <span className="hidden group-hover:inline-flex">Stop</span>
        </button>
      )}
      {stack.stackState === 'ACTIVE' && (
        <button type="button" onClick={() => stopStack(stack)} className={classEnabled}>
          <FontAwesomeIcon icon={faStop} />
          &nbsp;&nbsp;
          <span className="group-hover:hidden">Serving</span>
          <span className="hidden group-hover:inline-flex">Stop</span>
        </button>
      )}
      {stack.stackState === 'stopped' && (
        <button type="button" onClick={() => startStack(stack)} className={classEnabled}>
          <FontAwesomeIcon icon={faPlay} />
          &nbsp;&nbsp;Start
        </button>
      )}
    </>
  );
};

export default ActionButton;
